<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import { translation } from '$lib/locale/locale';
  import type { Track } from '$lib/models/track';
  import { AssetType } from '$lib/utils/asset';
  import { CategoryType, categoryLink } from '$lib/utils/category';
  import Tags from './tags.svelte';
  const { langHref } = translation();

  export let asset: Track;
</script>

<div class="details">
  {#if asset.description}
    <div class="description">
      {@html asset.description}
    </div>
  {/if}

  <div class="main-table">
    {#if asset.genres?.length && asset.type === AssetType.Track}
      <div class="column">
        <h2 class="title">{m['common.genres']()}</h2>
        <div class="links">
          {#each asset.genres as genre, index (genre.id)}
            <a href={categoryLink(langHref, genre, CategoryType.Genre)}>
              <div>{genre.name}</div>
            </a>{index !== asset.genres.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
    {#if asset.moods?.length && asset.type === AssetType.Track}
      <div class="column">
        <h2 class="title">{m['common.moods']()}</h2>
        <div class="links">
          {#each asset.moods as mood, index (mood.id)}
            <a href={categoryLink(langHref, mood, CategoryType.Mood)}>
              {mood.name}
            </a>{index !== asset.moods.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
    {#if asset.duration}
      <div class="column">
        <h2 class="title">{m['common.duration']()}</h2>
        <div>{asset.duration}</div>
      </div>
    {/if}

    {#if asset.tempo}
      <div class="column">
        <h2 class="title">{m['common.bpm']()}</h2>
        <div>{asset.tempo}</div>
      </div>
    {/if}
    {#if asset.energyLevels?.length && asset.type === AssetType.Track}
      <div class="column">
        <h2 class="title">{m['common.energy-levels']()}</h2>
        <div class="links">
          {#each asset.energyLevels as energy, index (energy.id)}
            <a href={categoryLink(langHref, energy, CategoryType.EnergyLevel)}>
              {energy.name}
            </a>{index !== asset.energyLevels.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
    {#if asset.types?.length && asset.type === AssetType.Track}
      <div class="column">
        <h2 class="title">{m['common.types']()}</h2>
        <div class="links">
          {#each asset.types as type, index (type.id)}
            <a href={categoryLink(langHref, type, CategoryType.Type)}>
              {type.name}
            </a>{index !== asset.types.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
    {#if asset.instruments?.length && asset.type === AssetType.Track}
      <div class="column">
        <h2 class="title">{m['common.instruments']()}</h2>
        <div class="links">
          {#each asset.instruments as instrument, index (instrument.id)}
            <a href={categoryLink(langHref, instrument, CategoryType.Instrument)}>
              {instrument.name}
            </a>{index !== asset.instruments.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
    {#if asset.themes?.length && asset.type === AssetType.Track}
      <div class="column">
        <h2 class="title">{m['common.themes']()}</h2>
        <div class="links">
          {#each asset.themes as theme, index (theme.id)}
            <a href={categoryLink(langHref, theme, CategoryType.Theme)}>
              {theme.name}
            </a>{index !== asset.themes.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
    {#if asset.categories?.length}
      <div class="column">
        <h2 class="title">{m['common.categories']()}</h2>
        <div class="links">
          {#each asset.categories as category, index (category.id)}
            <a class="category-link" href={categoryLink(langHref, category, CategoryType.SfxCategory)}>
              {category.name}
            </a>{index !== asset.categories.length - 1 ? ', ' : ''}
          {/each}
        </div>
      </div>
    {/if}
  </div>
  <div>
    <h2 class="tags-title">{m['common.tags']()}</h2>
    <div class="tags-row">
      <Tags
        tags={asset.tags}
        assetType={asset.type}
        borderColor="var(--border-500)"
        color="var(--text-invert-secondary)"
        hoverBackground="var(--charleston-black)"
      />
    </div>
  </div>
</div>

<style>
  .description {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .tags-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 24px;
  }
  .main-table {
    display: grid;
    grid-template-columns: 1fr 1fr 0.6fr;
  }
  .column {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    padding-right: 25px;
  }

  a {
    color: var(--text-invert);
    display: inline-block;
  }
  .tags-title {
    color: var(--text-invert-secondary);
    font-size: var(--base-font-size);
    margin-bottom: 12px;
    margin-top: 40px;
  }

  .details {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    color: var(--text-invert);
    font-size: var(--base-font-size);
    line-height: 24px;
  }

  .title {
    color: var(--text-invert-secondary);
    font-size: var(--base-font-size);
  }

  @media (max-width: 900px) {
    .main-table {
      grid-template-columns: 1fr 1fr;
    }
    .column {
      margin-top: 12px;
    }

    .tags-title {
      font-size: var(--xs-font-size);
    }

    .details {
      font-size: var(--xs-font-size);
    }
  }
</style>
